import { tr, usePartnerTranslation } from "../../../lib/language";
import React from "react";
import { Info, Lock } from "lucide-react";
import { FieldRow, SectionHeader, RadioCards } from "./fields";
import { PRODUCT_TYPES } from "./wizardConstants";

/**
 * Simplified Start step — single question, "What do you want to create?".
 * Once the user advances past this step the choice is locked and surfaced as
 * a read-only chip with a lock icon.
 */
const Step0Entry = ({ data, update, errors, locked = false }) => {
  usePartnerTranslation();
  const selected = PRODUCT_TYPES.find((t) => t.value === data.product_type);
  return (
    <section data-testid="step-start" className="space-y-6">
      <SectionHeader
        title={
          <>{tr("What do you want to create?")}<span className="ms-0.5 text-[#FF5757]">*</span>
          </>
        }
      />

      {locked ? (
        <div
          data-testid="product-type-locked"
          className="flex items-center gap-3 rounded-md border border-[#EAECEF] bg-[#FAFAFB] p-4"
        >
          <Lock className="h-4 w-4 flex-shrink-0 text-[#9BA1AB]" strokeWidth={1.8} />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold text-[#0F1115]">
              {selected?.label || data.product_type || "—"}
            </p>
            {selected?.description && (
              <p className="mt-0.5 text-xs text-[#6B7280]">{selected.description}</p>
            )}
          </div>
        </div>
      ) : (
        <FieldRow
          testid="field-product-type"
          error={errors.product_type}
        >
          <RadioCards
            value={data.product_type}
            onChange={(v) => update("product_type", v)}
            options={PRODUCT_TYPES.map((t) => ({
              value: t.value,
              label: t.label,
              description: t.description,
            }))}
            testid="radio-product-type"
          />
        </FieldRow>
      )}

      {!locked && (
        <div
          data-testid="product-type-warning"
          className="flex items-start gap-3 rounded-md border border-[#E4E7EC] bg-[#F7F8FA] p-4"
        >
          <Info
            className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#6B7280]"
            strokeWidth={1.8}
          />
          <p className="text-xs leading-relaxed text-[#4B5563]">
            <span className="font-semibold">{tr("Heads up:")}</span>{tr(" once you continue, the product type can't be changed. To switch, you'll need to start a new product from scratch.")}</p>
        </div>
      )}
    </section>
  );
};

export default Step0Entry;
